import {
    SETTINGS_INTEGRATIONS_LOYALTY_BONUS_CHARGE_RATE_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_BONUS_EXPIRE_RULES_PERIOD_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_BONUS_EXPIRE_RULES_TYPE_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_KEY_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_MAX_BONUS_DISCOUNT_PERCENT_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_WELCOME_BONUS_ACTIVATION_TYPE_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_WELCOME_BONUS_EXPIRE_PERIOD_SLUG,
} from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsLoyaltyIntegration = () =>
    useSettingsFactory({
        loyaltyKey: { path: SETTINGS_INTEGRATIONS_LOYALTY_KEY_SLUG },
        loyaltyEnabled: { path: SETTINGS_INTEGRATIONS_LOYALTY_ENABLED_SLUG },
        bonusChargeRate: { path: SETTINGS_INTEGRATIONS_LOYALTY_BONUS_CHARGE_RATE_SLUG },
        maxBonusDiscountPercent: { path: SETTINGS_INTEGRATIONS_LOYALTY_MAX_BONUS_DISCOUNT_PERCENT_SLUG },
        bonusExpireRulesType: { path: SETTINGS_INTEGRATIONS_LOYALTY_BONUS_EXPIRE_RULES_TYPE_SLUG },
        bonusExpireRulesPeriod: { path: SETTINGS_INTEGRATIONS_LOYALTY_BONUS_EXPIRE_RULES_PERIOD_SLUG },
        welcomeBonusActivationType: { path: SETTINGS_INTEGRATIONS_LOYALTY_WELCOME_BONUS_ACTIVATION_TYPE_SLUG },
        welcomeBonusExpirePeriod: { path: SETTINGS_INTEGRATIONS_LOYALTY_WELCOME_BONUS_EXPIRE_PERIOD_SLUG },
    });

export type LoyaltyIntegrationSettingsValues = ReturnType<typeof useSettingsLoyaltyIntegration>['values'];
